import { call, put } from 'redux-saga/effects';
import Swal from 'sweetalert2';
import { notificationSettingsApi } from '../../../api';
import {
    getNotificationSettingsSuccess,
    getNotificationSettingsFail,
    createNotificationSettingSuccess,
    createNotificationSettingFail,
    updateNotificationSettingSuccess,
    updateNotificationSettingFail,
    deleteNotificationSettingSuccess,
    deleteNotificationSettingFail,
    setNotificationSettingsLoading
} from '../actions/notificationSettingsActions';

export function* getNotificationSettingsSaga() {
    const token = sessionStorage.getItem('token');
    try {
        const resp = yield call(notificationSettingsApi.getAll, { token });
        yield put(getNotificationSettingsSuccess(resp.data));
    } catch (error) {
        yield put(getNotificationSettingsFail(error.message));
    } finally {
        yield put(setNotificationSettingsLoading(false));
    }
}

export function* createNotificationSettingSaga(action) {
    const token = sessionStorage.getItem('token');
    try {
        const resp = yield call(notificationSettingsApi.create, { data: action.payload, token });
        yield put(createNotificationSettingSuccess(resp.data));
        yield call([Swal, Swal.fire], {
            icon: 'success',
            title: 'Succès',
            text: 'Paramètre de notification créé avec succès',
            timer: 2000,
            showConfirmButton: false
        });
    } catch (error) {
        yield put(createNotificationSettingFail(error.message));
        yield call([Swal, Swal.fire], {
            icon: 'error',
            title: 'Erreur',
            text: 'Erreur lors de la création du paramètre',
        });
    }
}

export function* updateNotificationSettingSaga(action) {
    const token = sessionStorage.getItem('token');
    try {
        const resp = yield call(notificationSettingsApi.update, { 
            id: action.payload.id, 
            data: action.payload.settingData, 
            token 
        });
        yield put(updateNotificationSettingSuccess(resp.data));
        yield call([Swal, Swal.fire], {
            icon: 'success',
            title: 'Succès',
            text: 'Paramètre de notification mis à jour avec succès',
            timer: 2000,
            showConfirmButton: false
        });
    } catch (error) {
        yield put(updateNotificationSettingFail(error.message));
        yield call([Swal, Swal.fire], {
            icon: 'error',
            title: 'Erreur',
            text: 'Erreur lors de la mise à jour',
        });
    }
}

export function* deleteNotificationSettingSaga(action) {
    const token = sessionStorage.getItem('token');
    try {
        yield call(notificationSettingsApi.delete, { id: action.payload.id, token });
        yield put(deleteNotificationSettingSuccess(action.payload.id));
        yield call([Swal, Swal.fire], {
            icon: 'success',
            title: 'Succès',
            text: 'Paramètre supprimé avec succès',
            timer: 2000,
            showConfirmButton: false
        });
    } catch (error) {
        yield put(deleteNotificationSettingFail(error.message));
        yield call([Swal, Swal.fire], {
            icon: 'error',
            title: 'Erreur',
            text: 'Erreur lors de la suppression',
        });
    }
}
